import cn from "classnames";
import PanelTemplate from "components/shared/profile/panel";
import React from "react";
import { config, initialState } from "./config";

class BidCarsPlanningSettings extends PanelTemplate {
    renderBody = () => {
        const { editable, config } = this.props;
        const { allowableDistanceFromLastBidPoint, updateFrequency } = config;
        return (
            <>
                {this.renderField({
                    ...allowableDistanceFromLastBidPoint,
                    disabled: !editable,
                    inputBottomText: (
                        <small className="text-muted font-italic">
                            Машины, которые дальше указанного значения, будут выделены в планировании
                        </small>
                    ),
                })}
                {this.renderField({
                    ...updateFrequency,
                    disabled: !editable,
                })}
            </>
        );
    };

    render() {
        const cname = cn("card card-body mb-3", {
            "border-danger": !this.state.isValid,
        });
        return (
            <div className={cname}>
                <div className="row">
                    <div className="col-sm-4">
                        <h5>Настройки планирования</h5>
                    </div>
                    <div className="col-sm-8">
                        {this.renderBody()}
                        {this.renderButton()}
                    </div>
                </div>
            </div>
        );
    }
}

const ConfiguredPanel = (props) => <BidCarsPlanningSettings {...props} config={config} initialState={initialState} />;

export default ConfiguredPanel;
